import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureImgCloudComponent } from './feature-img-cloud.component';

@NgModule({
  declarations: [FeatureImgCloudComponent],
  imports: [CommonModule],
  exports: [FeatureImgCloudComponent]
})
export class FeatureImgCloudModule {}
